import './index.css'
import './assets/styles/react-id-swiper/swiper.min.css'
import './assets/styles/radio-customize/radio.css'
import './assets/styles/checkbox-customize/checkbox.css'
import './assets/styles/antd-customize/modal.css'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './store'
import RouterProvider from './routers'
import { ThemeProvider } from 'react-jss'
import * as serviceWorker from './serviceWorker'
import './fonts'
import HotSwappingIntlProvider from './intl/hotswappingintl'
import defaultTheme from './assets/styles/themes/default'
import * as Sentry from '@sentry/react'
import config from './config'

serviceWorker.initA2hs()

if (
  (config.environment === 'prodution') ||
 (config.environment === 'development' && !window.location.host.includes('localhost'))
) {
  Sentry.init({ dsn: 'https://f1bc72f885a949d88958531fa94b6f5e@sentry.dimorder.com/2' })
}

const root = document.getElementById('root')

// ! enable ios to resize the web.
// ! if pinch and scroll happen in the same time, eventListener cannot stop the page from resizing.
// document.addEventListener('touchmove', (event) => {
//   var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
//   if (iOS) {
//     if (event.scale !== 1) { event.preventDefault() }
//   }
// }, { passive: false })

const Ele = () => (
  <Provider store={store}>
    <HotSwappingIntlProvider>
      <ThemeProvider theme={defaultTheme}>
        <RouterProvider />
      </ThemeProvider>
    </HotSwappingIntlProvider>
  </Provider>
)

/**
 * Global Config
 */
ReactDOM.render(
  <Ele />,
  root,
)
serviceWorker.register()



// WEBPACK FOOTER //
// ./src/index.js